import {
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
} from "react-hook-form";

export const getFieldError = (
  errorMessage?:
    | string
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<FieldValues>>
    | undefined,
): string => {
  if (typeof errorMessage === "string") {
    return errorMessage;
  } else if (typeof errorMessage === "object" && errorMessage.message) {
    return errorMessage.message.toString();
  }
  return "";
};
